const storageKey = (tourKey: string) => `tour.seen.${tourKey}`;

export function hasSeenTour(tourKey: string): boolean {
    try {
        return localStorage.getItem(storageKey(tourKey)) === "1";
    } catch {
        // localStorage unavailable; treat as seen so we never nag on every load
        return true;
    }
}

export function markTourSeen(tourKey: string) {
    try {
        localStorage.setItem(storageKey(tourKey), "1");
    } catch {
        // localStorage unavailable; nothing to persist
    }
}
